import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { round5 } from 'utilities/math';

const SamplesSpecificationsComponent = props =>
  <div className={classNames('font-14 flex space-between', props.className)}>
    <span className="inline-block pr-30">
      <span className="opacity-50">
        {props.meanLabel}
      </span>

      <br />

      <span className="mean">
        {round5(props.mean)}
      </span>
    </span>

    <span className="inline-block pr-30">
      <span className="opacity-50">
        {props.stdevLabel}
      </span>

      <br />

      <span className="stdev">
        {typeof props.stdev === 'number' ? round5(props.stdev) : props.stdev}
      </span>
    </span>

    <span className="inline-block pr-30">
      <span className="opacity-50">
        {props.amountLabel}
      </span>

      <br />

      <span className="amount">
        {props.amount}
      </span>
    </span>
  </div>;

SamplesSpecificationsComponent.propTypes = {
  mean: PropTypes.number.isRequired,
  meanLabel: PropTypes.string.isRequired,

  stdev: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  stdevLabel: PropTypes.string.isRequired,

  amount: PropTypes.number.isRequired,
  amountLabel: PropTypes.string.isRequired,

  className: PropTypes.string
};

SamplesSpecificationsComponent.defaultProps = {
  className: ''
};

export default SamplesSpecificationsComponent;
